import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { GbgrundstueckService, GrundstueckId, GrundstueckListEntry } from '../../../../core/gb-api';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { HistoryMode } from '../../../../core/services/HistoryMode';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { map } from 'rxjs/operators';
import { NavTarget } from '../../../components/link/link.component';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { KompaktGrundstueckComponent } from '../../../kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { HistoryDirective } from '../../../directives/history.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-alpgrundstuecke',
  templateUrl: './alpgrundstuecke.component.html',
  styleUrls: ['./alpgrundstuecke.component.scss'],
  imports: [
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    KompaktGrundstueckComponent,
    HistoryDirective,
    TranslatePipe
  ]
})
export class AlpgrundstueckeComponent extends AbstractComponent implements OnChanges, OnInit, OnDestroy {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<GrundstueckListEntry>;

  hasPermissionSeybuch: boolean;

  historischeDatenSubscription;

  @Input()
  navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK;

  @Input()
  anzeigenHistorischeDaten = true;
  @Input()
  tableFullWidth = false;
  @Input()
  hasRight = true;

  constructor(
    private timepointService: TimepointService,
    private grundstueckService: GbgrundstueckService,
    private appConfigService: AppConfigService,
    private appFormatConfigService: FormatConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSub(
      this.appFormatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.hasPermissionSeybuch = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.SEYBUCH_FOLIO);
      })
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe((hist) => {
      this.update();
    });
  }

  update() {
    const historischeDaten = this.anzeigenHistorischeDaten
      ? this.appConfigService.einstellungHistorischeDaten
      : HistoryMode.HistoryMode.OHNE_HIST;
    const timepointCtx = this.timepointService.timepointCtx;
    const observable = this.grundstueckService
      .loadGrundstueckById(
        //
        this._grundstueckId.id, //
        historischeDaten, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId //
      )
      .pipe(map((a) => a.alpgrundstuecke));
    this.listLoader = new ListLoaderObservable<GrundstueckListEntry>(undefined, 1, observable);
  }
}
